import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵinject, ɵɵelementContainerStart, ɵɵelement, ɵɵelementContainerEnd, ɵɵgetCurrentView, ɵɵtemplate, ɵɵlistener, ɵɵrestoreView, ɵɵreference, ɵɵnextContext, ɵɵadvance, ɵɵproperty, ɵɵtextInterpolate, ɵɵdirectiveInject, ɵɵtemplateRefExtractor, ɵɵtextInterpolate1, ɵɵpureFunction0, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { NgIf, CommonModule } from '@angular/common';
import { ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, RequiredValidator, NgControlStatus, NgModel, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CloudinaryImage, CloudinaryModule } from '@cloudinary/angular-5.x';
import { IonContent, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonInput, TextValueAccessor, IonButton, IonText, IonImg, IonIcon, IonCheckbox, BooleanValueAccessor, IonicModule } from '@ionic/angular';
import { Actions, EffectsModule, EffectsFeatureModule } from '@ngrx/effects';
import { createAction, props, createFeatureSelector, createSelector, select, Store, createReducer, on, StoreModule, StoreFeatureModule } from '@ngrx/store';
import { Cloudinary } from 'cloudinary-core';
import { CookieService } from 'ngx-cookie-service';
import { MessagesService, LoadingService, MessagesComponent, LoadingComponent, UtilLibModule } from 'util-lib';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { auth } from 'firebase';
import { BehaviorSubject, interval, from, combineLatest } from 'rxjs';
import { shareReplay, first, map, tap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { BobService } from 'data-model';
import { Router, ActivatedRoute } from '@angular/router';

class AuthLibService {
}
AuthLibService.ɵfac = function AuthLibService_Factory(t) { return new (t || AuthLibService)(); };
AuthLibService.ɵprov = ɵɵdefineInjectable({ token: AuthLibService, factory: AuthLibService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthLibService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();

class AuthLibComponent {
    constructor() { }
    ngOnInit() { }
}
AuthLibComponent.ɵfac = function AuthLibComponent_Factory(t) { return new (t || AuthLibComponent)(); };
AuthLibComponent.ɵcmp = ɵɵdefineComponent({ type: AuthLibComponent, selectors: [["auth-lib"]], decls: 2, vars: 0, template: function AuthLibComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, "auth-lib works!");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthLibComponent, [{
        type: Component,
        args: [{
                selector: 'auth-lib',
                template: ` <p>auth-lib works!</p> `,
                styles: [],
            }]
    }], function () { return []; }, null); })();

class AuthEffects {
    constructor(actions$) {
        this.actions$ = actions$;
        actions$.subscribe(action => {
            // console.log('EFFECT called ', action);
        });
    }
}
AuthEffects.ɵfac = function AuthEffects_Factory(t) { return new (t || AuthEffects)(ɵɵinject(Actions)); };
AuthEffects.ɵprov = ɵɵdefineInjectable({ token: AuthEffects, factory: AuthEffects.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthEffects, [{
        type: Injectable
    }], function () { return [{ type: Actions }]; }, null); })();

const login = createAction('[Auth Lib] Login Done', props());
const logout = createAction('[Auth Lib] Logout Done');
const saveProfileDetail = createAction('[Auth Lib] Save Profile Done', props());
const updateProfileDetail = createAction('[Auth Lib] Update Profile Done', props());
const signUpMethodChange = createAction('[Auth Lib] Signup method change', props());

var authLib_actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    login: login,
    logout: logout,
    saveProfileDetail: saveProfileDetail,
    updateProfileDetail: updateProfileDetail,
    signUpMethodChange: signUpMethodChange
});

const selectAuthState = createFeatureSelector('auth');
const isLoggedIn = createSelector(selectAuthState, authState => !!authState.user);
const isLoggedOut = createSelector(isLoggedIn, loggedIn => !loggedIn);
const user = createSelector(selectAuthState, authState => authState.user);
const userProfileDetail = createSelector(selectAuthState, authState => authState.profileDetail);
const selectSignUpMethod = createSelector(selectAuthState, authState => authState.defaultPage);

class AuthStoreService {
    // prod
    // public PROFILE_URL = 'https://jobs.terra.do/profile';
    // public Redirect_URL = 'https://welcome.terra.do/auth/logout';
    constructor(ngFireAuth, afStore, bobservice, cookieService, authStore, router, route, http) {
        this.ngFireAuth = ngFireAuth;
        this.afStore = afStore;
        this.bobservice = bobservice;
        this.cookieService = cookieService;
        this.authStore = authStore;
        this.router = router;
        this.route = route;
        this.http = http;
        this.firebaseTokenSubject = new BehaviorSubject('');
        this.firebaseToken$ = this.firebaseTokenSubject.asObservable();
        this.afterSignUpRedirect = '/home';
        this.websiteLoader = new BehaviorSubject(true);
        this.websiteLoader$ = this.websiteLoader.asObservable();
        this.titles = {
            main: 'Huddle',
            extra: 'by',
            sub: 'Build a network of peers and experts. Work on climate change now.',
        };
        // dev
        this.PROFILE_URL = 'https://terra-api.terra.do/dev/profile';
        this.Redirect_URL = 'https://welcome-dev.terra.do/auth/logout';
        this.sessionId = this.getUUID();
        this.isLoggedIn$ = this.authStore.pipe(select(isLoggedIn));
        this.isLoggedOut$ = this.authStore.pipe(select(isLoggedOut));
        this.user$ = this.authStore.pipe(select(user));
        this.profileDetail$ = this.authStore.pipe(select(userProfileDetail));
        this.activeMethod$ = this.authStore.pipe(select(selectSignUpMethod));
        this.ngFireAuth.authState.subscribe(u => {
            if (u) {
                // this.authSubject.next(user);
                u.getIdToken()
                    .then(data => {
                    this.refreshToken(u);
                    this.firebaseTokenSubject.next(data);
                    if (!!data) {
                        this.http
                            .get(`${this.PROFILE_URL}/email/${u.email}`, {
                            headers: new HttpHeaders({
                                'Content-Type': 'application/json',
                                Accept: 'application/json',
                                Authorization: 'Bearer ' + data,
                            }),
                        })
                            .pipe(shareReplay())
                            .subscribe((profile) => {
                            var _a, _b, _c;
                            if (Object.keys(profile).length > 0) {
                                const profileDetail = {
                                    firstName: profile.firstName,
                                    lastName: profile.lastName,
                                    multimedia: profile.multimedia,
                                    id: profile.id,
                                    title: profile.title,
                                    country: profile.country,
                                    state: profile.state,
                                    address: profile.address,
                                    shortDescription: profile.shortDescription,
                                    description: profile.description,
                                    slackHandle: profile.slackHandle,
                                    linkedIn: profile.linkedIn,
                                    twitterHandle: profile.twitterHandle,
                                    website: profile.website,
                                    resume: profile.resume,
                                    lastActive: profile.lastActive,
                                    mentoredPeople: profile.mentoredPeople,
                                    medias: profile.medias,
                                    location: profile.location,
                                    roles: profile.roles,
                                    active: profile.active,
                                    joinReason: profile.joinReason,
                                    superPower: profile.superPower,
                                    helpWithStr: profile.helpWithStr,
                                    helpNeedStr: profile.helpNeedStr,
                                    published: profile.published,
                                    testimonials: profile.testimonials,
                                    highlights: profile.highlights,
                                    activities: profile.activities,
                                    email: profile.email,
                                    visibilityType: profile.visibilityType,
                                    isOnboarded: profile.isOnboarded,
                                    huddleOnboarded: profile.huddleOnboarded,
                                    courses: profile.courses,
                                    interests: profile.interests,
                                    city: profile.city,
                                    fellowships: profile.fellowships,
                                    availability: profile.availability,
                                };
                                const indentifyProp = {
                                    firstName: profile.firstName,
                                    lastName: profile.lastName,
                                    multimedia: profile.multimedia,
                                    id: profile.id,
                                    title: profile.title,
                                    country: profile.country,
                                    state: profile.state,
                                    slackHandle: !!profile.slackHandle,
                                    linkedIn: !!profile.linkedIn,
                                    twitterHandle: !!profile.twitterHandle,
                                    website: !!profile.website,
                                    resume: !!profile.resume,
                                    lastActive: profile.lastActive,
                                    roles: profile.roles,
                                    active: profile.active,
                                    joinReason: !!profile.joinReason,
                                    superPower: !!profile.superPower,
                                    helpWithStr: !!profile.helpWithStr,
                                    helpNeedStr: !!profile.helpNeedStr,
                                    published: profile.published,
                                    testimonials: !!profile.testimonials,
                                    highlights: !!profile.highlights,
                                    activities: !!profile.activities,
                                    email: profile.email,
                                    visibilityType: profile.visibilityType,
                                    isOnboarded: profile.isOnboarded,
                                    huddleOnboarded: profile.huddleOnboarded,
                                    courses: profile.courses,
                                    interests: !!profile.interests,
                                    cohortIds: (_a = profile.courses) === null || _a === void 0 ? void 0 : _a.map(el => el.cohortId),
                                    courseIds: (_b = profile.courses) === null || _b === void 0 ? void 0 : _b.map(el => el.courseId),
                                    groupIds: (_c = profile.courses) === null || _c === void 0 ? void 0 : _c.filter(el => !!el.groupId).map(el => el.groupId),
                                };
                                this.identifyAuthUser(profile.email, indentifyProp);
                                this.authStore.dispatch(saveProfileDetail({
                                    profileDetail,
                                }));
                                const userProfile = {
                                    uid: u.uid,
                                    displayName: u.displayName
                                        ? u.displayName
                                        : profile.firstName + ' ' + profile.lastName,
                                    email: u.email,
                                    emailVerified: u.emailVerified,
                                    photoURL: u.photoURL,
                                    phoneNumber: u.phoneNumber,
                                };
                                this.authStore.dispatch(login({ user: userProfile }));
                                this.activeMethod$.pipe(first()).subscribe(str => {
                                    window.localStorage.removeItem('returnUrl');
                                    console.log('this is method auth service', str);
                                    if (str === 'signup') {
                                        this.router.navigate([this.afterSignUpRedirect]);
                                    }
                                    else if (str === 'redirect') {
                                        const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
                                        console.log(' i am return url auth service', returnUrl);
                                        if (returnUrl) {
                                            this.router.navigate([returnUrl]);
                                        }
                                    }
                                });
                                this.websiteLoader.next(false);
                            }
                            else {
                                const userProfile = {
                                    uid: u.uid,
                                    displayName: u.email,
                                    email: u.email,
                                    emailVerified: u.emailVerified,
                                    photoURL: u.photoURL,
                                    phoneNumber: u.phoneNumber,
                                };
                                this.authStore.dispatch(saveProfileDetail({
                                    profileDetail: {
                                        firstName: '',
                                        lastName: '',
                                        multimedia: '',
                                        id: 0,
                                        title: '',
                                        country: '',
                                        city: '',
                                        state: '',
                                        address: '',
                                        shortDescription: '',
                                        description: '',
                                        slackHandle: '',
                                        linkedIn: '',
                                        website: '',
                                        twitterHandle: '',
                                        resume: '',
                                        roles: [],
                                        email: '',
                                        visibilityType: '',
                                        interests: [],
                                        fellowships: [],
                                        availability: null,
                                    },
                                }));
                                this.authStore.dispatch(login({ user: userProfile }));
                                this.websiteLoader.next(false);
                                this.router.navigate(['/no-data-found']);
                            }
                        });
                    }
                })
                    .catch(error => {
                    this.websiteLoader.next(false);
                    // this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
                    // if (this.returnUrl != '') {
                    // 	this.router.navigateByUrl(this.returnUrl);
                    // }
                    // this.returnUrl =
                    // 	this.route.snapshot.queryParamMap.get['returnUrl'] || '';
                    // this.route.queryParamMap.subscribe(params => {
                    // 	this.returnUrl = params['params']['returnUrl'] || '';
                    // });
                    // this.router.navigate(['/login/auth'], {
                    // 	queryParams: { returnUrl: this.returnUrl },
                    // });
                });
                const userProfile = {
                    uid: u.uid,
                    displayName: u.displayName,
                    email: u.email,
                    emailVerified: u.emailVerified,
                    photoURL: u.photoURL,
                    phoneNumber: u.phoneNumber,
                };
                this.authStore.dispatch(login({ user: userProfile }));
                // send to home page here
                // console.log('Going to home page');
                // this.router.navigateByUrl('/home');
                this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
                // this.returnUrl =
                // 	this.route.snapshot.queryParamMap.get['returnUrl'] || '';
                // this.route.queryParamMap.subscribe(params => {
                // 	this.returnUrl = params['params']['returnUrl'] || '';
                // });
                if (this.returnUrl == '') {
                    this.returnUrl = window.localStorage.getItem('returnUrl');
                }
                window.localStorage.removeItem('returnUrl');
                console.log('auth store service line 302', this.returnUrl);
                if (this.returnUrl !== '') {
                    this.router.navigateByUrl(this.returnUrl);
                }
                else {
                    this.activeMethod$.pipe(first()).subscribe(str => {
                        console.log('auth lib console', str);
                        if ((!!str && str !== 'signup' && str !== 'redirect') ||
                            str === '') {
                            this.router.navigate(['/home']);
                        }
                    });
                }
                // alert(router.url);
            }
            else if (this.cookieService.get('earth_token')) {
                const token = this.cookieService.get('earth_token');
                this.ngFireAuth
                    .setPersistence(auth.Auth.Persistence.LOCAL)
                    .then(() => {
                    return this.ngFireAuth.signInWithCustomToken(token);
                })
                    .then(res => {
                    if (!res.user) {
                        this.websiteLoader.next(false);
                    }
                })
                    .catch(error => {
                    this.websiteLoader.next(false);
                });
            }
            else {
                this.websiteLoader.next(false);
            }
        }, err => {
            this.logout();
        });
    }
    refreshToken(u) {
        interval(1 * 60 * 1000).subscribe(() => {
            u.getIdToken().then(data => {
                this.firebaseTokenSubject.next(data);
            });
        });
    }
    loginMethodChange(method) {
        this.authStore.dispatch(signUpMethodChange({ method }));
    }
    login(email, password) {
        return from(this.ngFireAuth.signInWithEmailAndPassword(email, password)).pipe(map(res => res.user), tap(u2 => {
            // console.log('u2 ===> ', u2);
            // this.ngFireAuth.authState;
            // this.authSubject.next(user);
            const loginEvent = {};
            loginEvent['event'] = 100;
            loginEvent['type'] = 'login';
            loginEvent['provider'] = 'password';
            this.logAuthUserAction(loginEvent);
            this.identifyAuthUser(email, null);
            this.fetchandSetToken(u2);
        }), shareReplay());
    }
    fetchandSetToken(user3) {
        fetch('https://us-central1-hubble-prod-dcbd4.cloudfunctions.net/minttoken?uid=' +
            user3.uid, {
            method: 'GET',
        })
            .then(response => {
            return response.json();
        })
            .then(data => {
            this.setCookie('earth_token', data.token);
        });
    }
    setCookie(name, val) {
        const date = new Date();
        const value = val;
        // Set it expire in 7 days
        date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
        // Set it
        this.cookieService.set(name, value, date, '/', '.terra.do');
        /*this.window.document.cookie =
            name +
            '=' +
            value +
            ';expires=' +
            date.toUTCString() +
            ';path=/;domain=.terra.do;';*/
    }
    googleLogin() {
        return from(this.ngFireAuth.signInWithPopup(new auth.GoogleAuthProvider())).pipe(map(res => res.user), tap(u2 => {
            const loginEvent = {};
            loginEvent['event'] = 100;
            loginEvent['type'] = 'login';
            loginEvent['provider'] = 'google';
            this.logAuthUserAction(loginEvent);
            this.identifyAuthUser(u2.email, null);
            this.fetchandSetToken(u2);
            // this.authSubject.next(user);
        }), shareReplay());
    }
    googleSignup(subscribedToNewsletter) {
        return from(this.ngFireAuth.signInWithPopup(new auth.GoogleAuthProvider())).pipe(map(res => res.user), tap(user4 => {
            this.setUserData(user4, user4.displayName, subscribedToNewsletter);
        }), tap(user5 => {
            this.fetchandSetToken(user5);
            // this.authSubject.next(user);
        }), shareReplay());
    }
    getUUID() {
        const length = 16;
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    setUserData(user6, name, checked) {
        // const userRef: AngularFirestoreDocument<any> = this.afStore.doc(`users/${user.uid}`);
        const userData = {
            uid: user6.uid,
            email: user6.email,
            displayName: name || user6.displayName,
            photoURL: user6.photoURL,
            emailVerified: user6.emailVerified,
            timeStamp: new Date().getTime() + '',
        };
        if (checked)
            userData['newsletter'] = 'newsletter';
        const urlParams = new URLSearchParams(window.location.search);
        const redirectUrl = urlParams.get('redirectUrl');
        if (redirectUrl != null) {
            const redirectUrlParams = new URLSearchParams('?' + redirectUrl.split('?')[1]);
            const medium = redirectUrlParams.get('utm_medium') || '';
            const source = redirectUrlParams.get('utm_source') || '';
            const campaign = redirectUrlParams.get('utm_campaign') || '';
            userData['utmParams'] = medium + '_' + source + '_' + campaign;
        }
        this.bobservice.createuserlead(user6);
        // TODO: May be move to firestore service
        return from(this.afStore
            .collection('users')
            .doc(user6.uid)
            .set(userData, { merge: true }));
    }
    registerUser(name, email, password, subscribedToNewsletter) {
        return from(this.ngFireAuth.createUserWithEmailAndPassword(email, password)).pipe(tap(res => {
            res.user.updateProfile({ displayName: name });
        }), tap(res => {
            this.setUserData(res.user, name, subscribedToNewsletter);
            this.fetchandSetToken(res.user);
        }), shareReplay());
    }
    resetPassword(email) {
        return from(this.ngFireAuth.sendPasswordResetEmail(email));
    }
    getUserWithEmail(email) {
        return from(this.afStore.firestore
            .collection('users')
            .where('email', '==', email)
            .get());
    }
    sendSignInLinkToEmail(email, linkObj) {
        return from(this.ngFireAuth.sendSignInLinkToEmail(email, linkObj));
    }
    signInWithEmailLink(email, link) {
        return from(this.ngFireAuth.signInWithEmailLink(email, link));
    }
    isSignInWithEmailLink(link) {
        return this.ngFireAuth.isSignInWithEmailLink(link);
    }
    logout() {
        window['rudderanalytics'].reset();
        this.cookieService.delete('earth_token', '/', '.terra.do');
        this.authStore.dispatch(logout());
        this.ngFireAuth.signOut();
        setTimeout(() => {
            window.open(this.Redirect_URL, '_self');
        }, 2000);
    }
    logAuthUserAction(messageJSON) {
        // console.log('LOG Auth Called');
        this.user$.subscribe(u => {
            // console.log('XXXX', u);
            if (u != null) {
                messageJSON['email'] = u['email'];
                messageJSON['sessionId'] = this.sessionId;
                messageJSON['clientTimestamp'] = new Date().getTime();
                window['rudderanalytics'].track(messageJSON.type, messageJSON, () => { });
                // this.websocket.sendMessage(messageJSON);
            }
            else {
                // non-logged in is ignored...
                // messageJSON['email'] = 'tokenUser@terra.do';
            }
        });
    }
    identifyAuthUser(email, messageJSON) {
        window['rudderanalytics'].identify(email, messageJSON, () => { });
    }
    eventClick(messageJSON) {
        combineLatest([this.profileDetail$, this.user$])
            .pipe(map(([profileDetail, userFire]) => {
            if (profileDetail != null && userFire != null) {
                messageJSON['profileId'] = profileDetail === null || profileDetail === void 0 ? void 0 : profileDetail.id;
                messageJSON['email'] = userFire['email'];
                messageJSON['sessionId'] = this.sessionId;
                messageJSON['clientTimestamp'] = new Date().getTime();
                window['rudderanalytics'].track(messageJSON.type, messageJSON, () => { });
                // this.websocket.sendMessage(messageJSON);
            }
            else {
                // non-logged in is ignored...
                // messageJSON['email'] = 'tokenUser@terra.do';
            }
        }))
            .subscribe();
    }
}
AuthStoreService.ɵfac = function AuthStoreService_Factory(t) { return new (t || AuthStoreService)(ɵɵinject(AngularFireAuth), ɵɵinject(AngularFirestore), ɵɵinject(BobService), ɵɵinject(CookieService), ɵɵinject(Store), ɵɵinject(Router), ɵɵinject(ActivatedRoute), ɵɵinject(HttpClient)); };
AuthStoreService.ɵprov = ɵɵdefineInjectable({ token: AuthStoreService, factory: AuthStoreService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthStoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: AngularFireAuth }, { type: AngularFirestore }, { type: BobService }, { type: CookieService }, { type: Store }, { type: Router }, { type: ActivatedRoute }, { type: HttpClient }]; }, null); })();

function ForgotEmailComponent_ng_container_15_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 19);
    ɵɵelement(2, "img", 20);
    ɵɵelementStart(3, "span");
    ɵɵtext(4, "This email id is not associated with Terra.do");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function ForgotEmailComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 12);
    ɵɵtext(2, "Forgot Password?");
    ɵɵelementEnd();
    ɵɵelementStart(3, "form");
    ɵɵelementStart(4, "ion-item", 13);
    ɵɵelementStart(5, "ion-label", 14);
    ɵɵtext(6, "Enter your email id");
    ɵɵelementEnd();
    ɵɵelement(7, "ion-input", 15, 16);
    ɵɵelementEnd();
    ɵɵtemplate(9, ForgotEmailComponent_ng_container_15_ng_container_9_Template, 5, 0, "ng-container", 17);
    ɵɵelementStart(10, "ion-row");
    ɵɵelementStart(11, "ion-col");
    ɵɵelementStart(12, "ion-button", 18);
    ɵɵlistener("click", function ForgotEmailComponent_ng_container_15_Template_ion_button_click_12_listener() { ɵɵrestoreView(_r6); const _r3 = ɵɵreference(8); const ctx_r5 = ɵɵnextContext(); return ctx_r5.resetPassword(_r3); });
    ɵɵtext(13, "Reset the password");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(9);
    ɵɵproperty("ngIf", ctx_r0.hasError);
} }
function ForgotEmailComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵelement(1, "img", 22);
    ɵɵelementStart(2, "div", 23);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r2.confirmMessage);
} }
class ForgotEmailComponent {
    constructor(router, auth, messages, loading) {
        this.router = router;
        this.auth = auth;
        this.messages = messages;
        this.loading = loading;
        this.passwordResetEmailSent = false;
        this.confirmMessage = '';
        this.hasError = false;
        // block
    }
    ngOnInit() {
        // block
    }
    goToSignUpPage() {
        this.auth.loginMethodChange('signup');
    }
    resetPassword(email) {
        const userWithEmail$ = this.auth.getUserWithEmail(email.value);
        this.loading.showLoaderUntilCompleted(userWithEmail$).subscribe(snapshot => {
            if (snapshot.empty) {
                this.hasError = true;
                return;
            }
            snapshot.forEach(doc => {
                // this.authService.resetPassword(doc.data().email);
                const redirectUrl = window.location.host + '/login/loginemaillink';
                const actionCodeSettings = {
                    url: redirectUrl,
                    handleCodeInApp: true,
                };
                this.auth
                    .sendSignInLinkToEmail(doc.data().email, actionCodeSettings)
                    .subscribe(() => {
                    window.localStorage.setItem('emailForSignIn', email);
                    this.passwordResetEmailSent = true;
                    this.confirmMessage =
                        'We have sent a link to ' +
                            doc.data().email +
                            ' to log you in with a link.';
                });
            });
        }, err => {
            const message = 'Something went wrong! Please try again';
            this.messages.showErrors(message);
        });
    }
}
ForgotEmailComponent.ɵfac = function ForgotEmailComponent_Factory(t) { return new (t || ForgotEmailComponent)(ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(LoadingService)); };
ForgotEmailComponent.ɵcmp = ɵɵdefineComponent({ type: ForgotEmailComponent, selectors: [["auth-forgot-email"]], decls: 25, vars: 5, consts: [[1, "login-grid"], [1, "terra-info"], ["size", "12", 1, "montserrat", "main-title"], ["size", "12", 1, "sub-title"], [1, "login-row"], ["size", "12", 1, "rightPanel"], ["size", "12"], [4, "ngIf", "ngIfElse"], ["elseBlock", ""], [1, "forgotContainer"], [1, "forgotPassword-text"], [3, "click"], [1, "signupTagline", "montserrat"], ["lines", "full", 1, "signupFormItem"], ["position", "floating"], ["type", "text", "required", ""], ["email", ""], [4, "ngIf"], ["type", "submit", "expand", "block", 1, "actionable", "yellowButton", 3, "click"], [1, "errorMessageClass"], ["src", "../assets/x_circle_red.svg"], [2, "text-align", "center"], ["src", "../assets/awesome.svg", 2, "height", "60px"], [1, "confirmTextMessage"]], template: function ForgotEmailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "util-messages");
        ɵɵelementStart(1, "ion-content");
        ɵɵelementStart(2, "ion-grid", 0);
        ɵɵelementStart(3, "ion-row", 1);
        ɵɵelementStart(4, "ion-col", 2);
        ɵɵelementStart(5, "b");
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "ion-col", 3);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "ion-row", 4);
        ɵɵelementStart(11, "ion-col", 5);
        ɵɵelementStart(12, "ion-grid");
        ɵɵelementStart(13, "ion-row");
        ɵɵelementStart(14, "ion-col", 6);
        ɵɵtemplate(15, ForgotEmailComponent_ng_container_15_Template, 14, 1, "ng-container", 7);
        ɵɵtemplate(16, ForgotEmailComponent_ng_template_16_Template, 4, 1, "ng-template", null, 8, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(18, "ion-row");
        ɵɵelementStart(19, "ion-col", 9);
        ɵɵelementStart(20, "div", 10);
        ɵɵtext(21, " Don't have an account? ");
        ɵɵelementStart(22, "a", 11);
        ɵɵlistener("click", function ForgotEmailComponent_Template_a_click_22_listener() { return ctx.goToSignUpPage(); });
        ɵɵtext(23, "Sign up");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(24, "util-loading");
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(17);
        ɵɵadvance(6);
        ɵɵtextInterpolate(ctx.auth.titles.main);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.auth.titles.extra, " Terra.do");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.auth.titles.sub);
        ɵɵadvance(6);
        ɵɵproperty("ngIf", !ctx.passwordResetEmailSent)("ngIfElse", _r1);
    } }, directives: [MessagesComponent, IonContent, IonGrid, IonRow, IonCol, NgIf, LoadingComponent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, IonItem, IonLabel, IonInput, TextValueAccessor, IonButton], styles: [".leftPanel[_ngcontent-%COMP%]{background:hsla(0,0%,86.3%,.12);height:100vh}ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{--ion-grid-padding:0;padding:0}.loginDiv[_ngcontent-%COMP%]{color:#000;font-family:Montserrat,sans-serif;font-size:18px;font-style:normal;font-weight:400;line-height:20px;margin:45px 0;position:absolute;right:0}.actionable[_ngcontent-%COMP%]{border-radius:4px;color:#fff;font-family:var(--ion-font-family-text);font-size:20px;font-style:normal;font-weight:500;height:50px;letter-spacing:0;line-height:28px;text-transform:capitalize}.yellowButton[_ngcontent-%COMP%]{--background:linear-gradient(180deg,#ffd555,#ffc410);background:linear-gradient(180deg,#ffd555,#ffc410);color:#000}.signupFormItem[_ngcontent-%COMP%]{--border-radius:4px;--border-width:1px;margin:20px 0}.confirmTextMessage[_ngcontent-%COMP%]{color:#565656;font-family:var(--ion-font-family-text);font-size:24px;font-style:normal;font-weight:400;line-height:30px;margin:20px 0}", ".terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{border-bottom:1px solid #fff;color:#fff;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#fff;font-size:16px;line-height:150%;padding-bottom:40px;padding-top:20px;text-align:center}.login-grid[_ngcontent-%COMP%]{margin:auto;max-width:470px}.login-row[_ngcontent-%COMP%]{background:#fff;border-radius:8px;box-shadow:0 0 8px rgba(0,0,0,.25);padding:20px}.signupTagline[_ngcontent-%COMP%]{color:#000;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.forgotContainer[_ngcontent-%COMP%]{padding-top:20px}.forgotContainer[_ngcontent-%COMP%]   .forgotPassword-text[_ngcontent-%COMP%]{font-size:18px;font-style:normal;font-weight:500;line-height:10px;text-align:left}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:10px!important}@media (max-width:575.98px){.terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{font-size:24px;padding-bottom:10px}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{font-size:16px;padding-bottom:20px}.login-row[_ngcontent-%COMP%]{padding:10px}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:20px!important}}@media (min-width:768.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:60px!important;padding-top:60px!important}}@media (max-width:768px) and (min-width:510.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:80px!important;padding-top:80px!important}}@media (max-width:510px){.login-grid[_ngcontent-%COMP%]{padding:30px 20px 20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ForgotEmailComponent, [{
        type: Component,
        args: [{
                selector: 'auth-forgot-email',
                templateUrl: './forgot-email.component.html',
                styleUrls: ['./forgot-email.component.css', '../common.scss'],
            }]
    }], function () { return [{ type: Router }, { type: AuthStoreService }, { type: MessagesService }, { type: LoadingService }]; }, null); })();

function ForgotPasswordComponent_ng_container_15_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 19);
    ɵɵelement(2, "img", 20);
    ɵɵelementStart(3, "span");
    ɵɵtext(4, "This email id is not associated with Terra.do");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} }
function ForgotPasswordComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 12);
    ɵɵtext(2, "Forgot Password?");
    ɵɵelementEnd();
    ɵɵelementStart(3, "form");
    ɵɵelementStart(4, "ion-item", 13);
    ɵɵelementStart(5, "ion-label", 14);
    ɵɵtext(6, "Enter your email id");
    ɵɵelementEnd();
    ɵɵelement(7, "ion-input", 15, 16);
    ɵɵelementEnd();
    ɵɵtemplate(9, ForgotPasswordComponent_ng_container_15_ng_container_9_Template, 5, 0, "ng-container", 17);
    ɵɵelementStart(10, "ion-row");
    ɵɵelementStart(11, "ion-col");
    ɵɵelementStart(12, "ion-button", 18);
    ɵɵlistener("click", function ForgotPasswordComponent_ng_container_15_Template_ion_button_click_12_listener() { ɵɵrestoreView(_r6); const _r3 = ɵɵreference(8); const ctx_r5 = ɵɵnextContext(); return ctx_r5.resetPassword(_r3); });
    ɵɵtext(13, "Reset the password");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(9);
    ɵɵproperty("ngIf", ctx_r0.hasError);
} }
function ForgotPasswordComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 21);
    ɵɵelement(1, "img", 22);
    ɵɵelementStart(2, "div", 23);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r2.confirmMessage);
} }
class ForgotPasswordComponent {
    constructor(router, auth, messages, loading) {
        this.router = router;
        this.auth = auth;
        this.messages = messages;
        this.loading = loading;
        this.passwordResetEmailSent = false;
        this.confirmMessage = '';
        // block
    }
    ngOnInit() {
        // block
    }
    goToSignUpPage() {
        this.auth.loginMethodChange('signup');
    }
    resetPassword(email) {
        const resetPass$ = this.auth.resetPassword(email.value);
        this.loading.showLoaderUntilCompleted(resetPass$).subscribe(() => {
            this.passwordResetEmailSent = true;
            this.confirmMessage =
                'We have sent a link to ' + email.value + ' to reset your password.';
        }, err => {
            // message service to be used to display this message
            // alert('Login failed!');
            const message = 'Could not log you in';
            this.messages.showErrors(message);
            // console.log(message, err);
        });
    }
}
ForgotPasswordComponent.ɵfac = function ForgotPasswordComponent_Factory(t) { return new (t || ForgotPasswordComponent)(ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(LoadingService)); };
ForgotPasswordComponent.ɵcmp = ɵɵdefineComponent({ type: ForgotPasswordComponent, selectors: [["auth-forgot-my-password"]], decls: 25, vars: 5, consts: [[1, "login-grid"], [1, "terra-info"], ["size", "12", 1, "montserrat", "main-title"], ["size", "12", 1, "sub-title"], [1, "login-row"], ["size", "12", 1, "rightPanel"], ["size", "12"], [4, "ngIf", "ngIfElse"], ["elseBlock", ""], [1, "forgotContainer"], [1, "forgotPassword-text"], [3, "click"], [1, "signupTagline", "montserrat"], ["lines", "full", 1, "signupFormItem"], ["position", "floating"], ["type", "text", "required", ""], ["email", ""], [4, "ngIf"], ["type", "submit", "expand", "block", 1, "actionable", "yellowButton", 3, "click"], [1, "errorMessageClass"], ["src", "../assets/x_circle_red.svg"], [2, "text-align", "center"], ["src", "../assets/awesome.svg", 2, "height", "60px"], [1, "confirmTextMessage"]], template: function ForgotPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "util-messages");
        ɵɵelementStart(1, "ion-content");
        ɵɵelementStart(2, "ion-grid", 0);
        ɵɵelementStart(3, "ion-row", 1);
        ɵɵelementStart(4, "ion-col", 2);
        ɵɵelementStart(5, "b");
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "ion-col", 3);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "ion-row", 4);
        ɵɵelementStart(11, "ion-col", 5);
        ɵɵelementStart(12, "ion-grid");
        ɵɵelementStart(13, "ion-row");
        ɵɵelementStart(14, "ion-col", 6);
        ɵɵtemplate(15, ForgotPasswordComponent_ng_container_15_Template, 14, 1, "ng-container", 7);
        ɵɵtemplate(16, ForgotPasswordComponent_ng_template_16_Template, 4, 1, "ng-template", null, 8, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(18, "ion-row");
        ɵɵelementStart(19, "ion-col", 9);
        ɵɵelementStart(20, "div", 10);
        ɵɵtext(21, " Don't have an account? ");
        ɵɵelementStart(22, "a", 11);
        ɵɵlistener("click", function ForgotPasswordComponent_Template_a_click_22_listener() { return ctx.goToSignUpPage(); });
        ɵɵtext(23, "Sign up");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(24, "util-loading");
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(17);
        ɵɵadvance(6);
        ɵɵtextInterpolate(ctx.auth.titles.main);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.auth.titles.extra, " Terra.do");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.auth.titles.sub);
        ɵɵadvance(6);
        ɵɵproperty("ngIf", !ctx.passwordResetEmailSent)("ngIfElse", _r1);
    } }, directives: [MessagesComponent, IonContent, IonGrid, IonRow, IonCol, NgIf, LoadingComponent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, IonItem, IonLabel, IonInput, TextValueAccessor, IonButton], styles: [".leftPanel[_ngcontent-%COMP%]{background:hsla(0,0%,86.3%,.12);height:100vh}ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{--ion-grid-padding:0;padding:0}.loginDiv[_ngcontent-%COMP%]{color:#000;font-family:Montserrat,sans-serif;font-size:18px;font-style:normal;font-weight:400;line-height:20px;margin:45px 0;position:absolute;right:0}.actionable[_ngcontent-%COMP%]{border-radius:4px;color:#fff;font-family:var(--ion-font-family-text);font-size:20px;font-style:normal;font-weight:500;height:50px;letter-spacing:0;line-height:28px;text-transform:capitalize}.yellowButton[_ngcontent-%COMP%]{--background:linear-gradient(180deg,#ffd555,#ffc410);background:linear-gradient(180deg,#ffd555,#ffc410);color:#000}.signupFormItem[_ngcontent-%COMP%]{--border-radius:4px;--border-width:1px;margin:20px 0}.confirmTextMessage[_ngcontent-%COMP%]{color:#565656;font-family:var(--ion-font-family-text);font-size:24px;font-style:normal;font-weight:400;line-height:30px;margin:20px 0}", ".terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{border-bottom:1px solid #fff;color:#fff;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#fff;font-size:16px;line-height:150%;padding-bottom:40px;padding-top:20px;text-align:center}.login-grid[_ngcontent-%COMP%]{margin:auto;max-width:470px}.login-row[_ngcontent-%COMP%]{background:#fff;border-radius:8px;box-shadow:0 0 8px rgba(0,0,0,.25);padding:20px}.signupTagline[_ngcontent-%COMP%]{color:#000;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.forgotContainer[_ngcontent-%COMP%]{padding-top:20px}.forgotContainer[_ngcontent-%COMP%]   .forgotPassword-text[_ngcontent-%COMP%]{font-size:18px;font-style:normal;font-weight:500;line-height:10px;text-align:left}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:10px!important}@media (max-width:575.98px){.terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{font-size:24px;padding-bottom:10px}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{font-size:16px;padding-bottom:20px}.login-row[_ngcontent-%COMP%]{padding:10px}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:20px!important}}@media (min-width:768.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:60px!important;padding-top:60px!important}}@media (max-width:768px) and (min-width:510.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:80px!important;padding-top:80px!important}}@media (max-width:510px){.login-grid[_ngcontent-%COMP%]{padding:30px 20px 20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ForgotPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'auth-forgot-my-password',
                templateUrl: './forgot-password.component.html',
                styleUrls: ['./forgot-password.component.css', '../common.scss'],
            }]
    }], function () { return [{ type: Router }, { type: AuthStoreService }, { type: MessagesService }, { type: LoadingService }]; }, null); })();

class AuthGuard {
    constructor(authStore, authService, router) {
        this.authStore = authStore;
        this.authService = authService;
        this.router = router;
    }
    canActivate(route, state) {
        // route.url
        return this.authService.isLoggedIn$
            .pipe(
        // filter(val => val !== null),
        take(1), tap(loggedIn => {
            if (!loggedIn) {
                if (state.url != 'redirect') {
                    this.authService.loginMethodChange('redirect');
                }
                this.router.navigate(['/login/auth'], {
                    queryParams: { returnUrl: state.url },
                });
                // this.router.navigateByUrl('/login/auth?r=' + state.url);
            }
        }))
            .toPromise();
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵɵinject(Store), ɵɵinject(AuthStoreService), ɵɵinject(Router)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ token: AuthGuard, factory: AuthGuard.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return [{ type: Store }, { type: AuthStoreService }, { type: Router }]; }, null); })();

class LeftPanelComponent {
    constructor() {
        // block
    }
    ngOnInit() {
        // block
    }
}
LeftPanelComponent.ɵfac = function LeftPanelComponent_Factory(t) { return new (t || LeftPanelComponent)(); };
LeftPanelComponent.ɵcmp = ɵɵdefineComponent({ type: LeftPanelComponent, selectors: [["auth-left-panel"]], decls: 13, vars: 0, consts: [["size-xl", "10", "size-lg", "0", "size-xs", "0", "size-sm", "0", "offset", "1", 2, "height", "100vh", "position", "relative"], ["public-id", "terra-logo", "height", "40", "format", "png", 1, "logo"], ["color", "dark", 1, "ion-hide-xl-down"], [1, "login-tagline"], [1, "login-subtext"], ["src", "https://res.cloudinary.com/terra-do/image/upload/v1599724401/Misc/plant_small_b60a62ed7b0be363055efa814f272041_ujmybv.png", 1, "login-leaf-full"]], template: function LeftPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainerStart(0);
        ɵɵelementStart(1, "ion-grid");
        ɵɵelementStart(2, "ion-row");
        ɵɵelementStart(3, "ion-col", 0);
        ɵɵelement(4, "cl-image", 1);
        ɵɵelementStart(5, "ion-text", 2);
        ɵɵelementStart(6, "div", 3);
        ɵɵtext(7, "Work on #climatechange");
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 4);
        ɵɵtext(9, " Learn from top world experts. ");
        ɵɵelement(10, "br");
        ɵɵtext(11, " Do projects that use your skills ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(12, "ion-img", 5);
        ɵɵelementContainerEnd();
    } }, directives: [IonGrid, IonRow, IonCol, CloudinaryImage, IonText, IonImg], styles: [".login-tagline[_ngcontent-%COMP%]{color:#000;font-family:var(--ion-font-family-heading);font-size:44px;font-weight:900;line-height:50px;margin-top:120px}.login-subtext[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-size:22px;line-height:32px;margin-top:10px}.login-leaf-full[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;width:70%}.logo[_ngcontent-%COMP%]{display:block;margin-top:15px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LeftPanelComponent, [{
        type: Component,
        args: [{
                selector: 'auth-left-panel',
                templateUrl: './left-panel.component.html',
                styleUrls: ['./left-panel.component.css'],
            }]
    }], function () { return []; }, null); })();

class LoginComponent {
    constructor(router, auth, messages, loading) {
        this.router = router;
        this.auth = auth;
        this.messages = messages;
        this.loading = loading;
        this.isLoading = false;
    }
    ngOnInit() {
        /*
        blank
        */
    }
    login(email, password) {
        const login$ = this.auth.login(email.value.trim(), password.value);
        this.loading.showLoaderUntilCompleted(login$).subscribe(() => {
            /*input to be defined (return_url)
            forward to reurn url
            */
        }, err => {
            // message service to be used to display this message
            // alert('Login failed!');
            const message = 'Could not log you in';
            this.messages.showErrors(message);
            // console.log(message, err);
        });
    }
    goToForgotPassword() {
        this.auth.loginMethodChange('forgotpassword');
    }
    signupUsingGoogle() {
        const login$ = this.auth.googleLogin();
        this.loading.showLoaderUntilCompleted(login$).subscribe(() => {
            /*
            input to be defined (return_url)
            forward to reurn url
            */
        }, err => {
            // message service to be used to display this message
            // alert('Login failed!');
            const message = 'Could not log you in';
            this.messages.showErrors(message);
            // console.log(message, err);
        });
    }
    goToSignUpPage() {
        this.auth.loginMethodChange('signup');
    }
    goToForgotEmail() {
        this.auth.loginMethodChange('forgotemail');
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(LoadingService)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["auth-login"]], decls: 50, vars: 3, consts: [[1, "login-module"], [1, "login-grid"], [1, "terra-info"], ["size", "12", 1, "montserrat", "main-title"], ["size", "12", 1, "sub-title"], [1, "login-row"], ["size", "12", 1, "rightPanel"], ["size", "12"], [1, "signupTagline", "montserrat"], ["expand", "full", 1, "actionable", 3, "click"], ["name", "logo-google", 2, "margin-right", "15px"], [2, "margin-top", "20px"], [1, "seperator"], [1, "seperatorText"], ["lines", "full", 1, "signupFormItem"], ["position", "floating"], ["type", "text", "required", "", 3, "keyup.enter"], ["email", ""], ["type", "password", "required", "", 3, "keyup.enter"], ["password", ""], ["type", "submit", "expand", "block", 1, "actionable", "yellowButton", 3, "click"], [1, "forgotContainer"], [1, "forgotPassword-text", 3, "click"], [1, "forgotPassword-text", "secound-title"], [3, "click"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        const _r2 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "ion-content", 0);
        ɵɵelement(1, "util-messages");
        ɵɵelementStart(2, "ion-grid", 1);
        ɵɵelementStart(3, "ion-row", 2);
        ɵɵelementStart(4, "ion-col", 3);
        ɵɵelementStart(5, "b");
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "ion-col", 4);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "ion-row", 5);
        ɵɵelementStart(11, "ion-col", 6);
        ɵɵelementStart(12, "ion-grid");
        ɵɵelementStart(13, "ion-row");
        ɵɵelementStart(14, "ion-col", 7);
        ɵɵelementStart(15, "div", 8);
        ɵɵtext(16, "Sign in to Terra.do");
        ɵɵelementEnd();
        ɵɵelementStart(17, "ion-button", 9);
        ɵɵlistener("click", function LoginComponent_Template_ion_button_click_17_listener() { return ctx.signupUsingGoogle(); });
        ɵɵelement(18, "ion-icon", 10);
        ɵɵtext(19, " Sign in with Google ");
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 11);
        ɵɵelement(21, "div", 12);
        ɵɵelementStart(22, "div", 13);
        ɵɵtext(23, "Or");
        ɵɵelementEnd();
        ɵɵelement(24, "div", 12);
        ɵɵelementEnd();
        ɵɵelementStart(25, "form");
        ɵɵelementStart(26, "ion-item", 14);
        ɵɵelementStart(27, "ion-label", 15);
        ɵɵtext(28, "Email");
        ɵɵelementEnd();
        ɵɵelementStart(29, "ion-input", 16, 17);
        ɵɵlistener("keyup.enter", function LoginComponent_Template_ion_input_keyup_enter_29_listener() { ɵɵrestoreView(_r2); const _r0 = ɵɵreference(30); const _r1 = ɵɵreference(35); return ctx.login(_r0, _r1); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(31, "ion-item", 14);
        ɵɵelementStart(32, "ion-label", 15);
        ɵɵtext(33, "Password");
        ɵɵelementEnd();
        ɵɵelementStart(34, "ion-input", 18, 19);
        ɵɵlistener("keyup.enter", function LoginComponent_Template_ion_input_keyup_enter_34_listener() { ɵɵrestoreView(_r2); const _r0 = ɵɵreference(30); const _r1 = ɵɵreference(35); return ctx.login(_r0, _r1); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(36, "ion-row");
        ɵɵelementStart(37, "ion-col");
        ɵɵelementStart(38, "ion-button", 20);
        ɵɵlistener("click", function LoginComponent_Template_ion_button_click_38_listener() { ɵɵrestoreView(_r2); const _r0 = ɵɵreference(30); const _r1 = ɵɵreference(35); return ctx.login(_r0, _r1); });
        ɵɵtext(39, "Sign In");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(40, "ion-row");
        ɵɵelementStart(41, "ion-col", 21);
        ɵɵelementStart(42, "div");
        ɵɵelementStart(43, "a", 22);
        ɵɵlistener("click", function LoginComponent_Template_a_click_43_listener() { return ctx.goToForgotPassword(); });
        ɵɵtext(44, "Forgot Password?");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(45, "div", 23);
        ɵɵtext(46, " Don't have an account? ");
        ɵɵelementStart(47, "a", 24);
        ɵɵlistener("click", function LoginComponent_Template_a_click_47_listener() { return ctx.goToSignUpPage(); });
        ɵɵtext(48, "Sign up");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(49, "util-loading");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(6);
        ɵɵtextInterpolate(ctx.auth.titles.main);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.auth.titles.extra, " Terra.do");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.auth.titles.sub);
    } }, directives: [IonContent, MessagesComponent, IonGrid, IonRow, IonCol, IonButton, IonIcon, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, IonItem, IonLabel, IonInput, TextValueAccessor, LoadingComponent], styles: [".leftPanel[_ngcontent-%COMP%]{background:hsla(0,0%,86.3%,.12);height:100vh}ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{--ion-grid-padding:0;padding:0}.loginDiv[_ngcontent-%COMP%]{color:#000;font-family:Montserrat,sans-serif;font-size:18px;font-style:normal;font-weight:400;line-height:20px;margin:45px 0;position:absolute;right:0}.seperator[_ngcontent-%COMP%]{border-top:1px solid #d3d3d3;display:inline-block;width:44%}.seperatorText[_ngcontent-%COMP%]{color:#9f9f9f;display:inline-block;font-size:18px;font-weight:400;line-height:18px;text-align:center;vertical-align:sub;width:12%}.actionable[_ngcontent-%COMP%], .seperatorText[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-style:normal}.actionable[_ngcontent-%COMP%]{border-radius:4px;color:#fff;font-size:20px;font-weight:500;height:50px;letter-spacing:0;line-height:28px;text-transform:capitalize}.yellowButton[_ngcontent-%COMP%]{--background:linear-gradient(180deg,#ffd555,#ffc410);background:linear-gradient(180deg,#ffd555,#ffc410);color:#000}.signupFormItem[_ngcontent-%COMP%]{--border-radius:4px;--border-width:1px;margin:20px 0}a[_ngcontent-%COMP%]{cursor:pointer}.forgotEmail[_ngcontent-%COMP%]{margin-left:10px}", ".terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{border-bottom:1px solid #fff;color:#fff;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#fff;font-size:16px;line-height:150%;padding-bottom:40px;padding-top:20px;text-align:center}.login-grid[_ngcontent-%COMP%]{margin:auto;max-width:470px}.login-row[_ngcontent-%COMP%]{background:#fff;border-radius:8px;box-shadow:0 0 8px rgba(0,0,0,.25);padding:20px}.signupTagline[_ngcontent-%COMP%]{color:#000;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.forgotContainer[_ngcontent-%COMP%]{padding-top:20px}.forgotContainer[_ngcontent-%COMP%]   .forgotPassword-text[_ngcontent-%COMP%]{font-size:18px;font-style:normal;font-weight:500;line-height:10px;text-align:left}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:10px!important}@media (max-width:575.98px){.terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{font-size:24px;padding-bottom:10px}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{font-size:16px;padding-bottom:20px}.login-row[_ngcontent-%COMP%]{padding:10px}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:20px!important}}@media (min-width:768.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:60px!important;padding-top:60px!important}}@media (max-width:768px) and (min-width:510.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:80px!important;padding-top:80px!important}}@media (max-width:510px){.login-grid[_ngcontent-%COMP%]{padding:30px 20px 20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'auth-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.css', '../common.scss'],
            }]
    }], function () { return [{ type: Router }, { type: AuthStoreService }, { type: MessagesService }, { type: LoadingService }]; }, null); })();

class LoginemaillinkComponent {
    constructor(auth, messages, loading) {
        this.auth = auth;
        this.messages = messages;
        this.loading = loading;
    }
    ngOnInit() {
        if (this.auth.isSignInWithEmailLink(window.location.href)) {
            let email = window.localStorage.getItem('emailForSignIn');
            if (!email) {
                email = window.prompt('Please provide your email for confirmation');
            }
            const verification$ = this.auth.sendSignInLinkToEmail(email, window.location.href);
            this.loading.showLoaderUntilCompleted(verification$).subscribe(() => {
                window.localStorage.removeItem('emailForSignIn');
            }, err => {
                window.location.href = '/login/auth';
            });
        }
    }
}
LoginemaillinkComponent.ɵfac = function LoginemaillinkComponent_Factory(t) { return new (t || LoginemaillinkComponent)(ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(LoadingService)); };
LoginemaillinkComponent.ɵcmp = ɵɵdefineComponent({ type: LoginemaillinkComponent, selectors: [["auth-loginemaillink"]], decls: 4, vars: 0, consts: [[2, "padding", "20px", "text-align", "center"]], template: function LoginemaillinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "util-messages");
        ɵɵelementStart(1, "div", 0);
        ɵɵelementStart(2, "h1");
        ɵɵtext(3, "Logging...");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, directives: [MessagesComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginemaillinkComponent, [{
        type: Component,
        args: [{
                selector: 'auth-loginemaillink',
                templateUrl: './loginemaillink.component.html',
                styleUrls: ['./loginemaillink.component.css'],
            }]
    }], function () { return [{ type: AuthStoreService }, { type: MessagesService }, { type: LoadingService }]; }, null); })();

const initialAuthState = {
    user: undefined,
    profileDetail: undefined,
    defaultPage: ''
};
const authReducer = createReducer(initialAuthState, on(login, (state, action) => {
    return Object.assign(Object.assign({}, state), { user: action.user });
}), on(signUpMethodChange, (state, action) => {
    return Object.assign(Object.assign({}, state), { defaultPage: action.method });
}), on(logout, (state, action) => {
    return Object.assign(Object.assign({}, state), { user: undefined, profileDetail: undefined });
}), on(saveProfileDetail, (state, action) => {
    return Object.assign(Object.assign({}, state), { profileDetail: action.profileDetail });
}), on(updateProfileDetail, (state, action) => {
    return Object.assign(Object.assign({}, state), { profileDetail: action.profileDetail });
}));

const _c0 = function () { return { standalone: true }; };
class SignupComponent {
    constructor(router, auth, messages, loading) {
        this.router = router;
        this.auth = auth;
        this.messages = messages;
        this.loading = loading;
        this.terms = false;
        this.privacy = false;
    }
    ngOnInit() {
        // block
    }
    gotosigninpage() {
        this.auth.loginMethodChange('auth');
    }
    signupUsingGoogle(subscribeToNl) {
        const signup$ = this.auth.googleSignup(subscribeToNl.checked);
        this.loading.showLoaderUntilCompleted(signup$).subscribe(() => {
            const signupEvent = {};
            signupEvent['event'] = -1;
            signupEvent['type'] = 'signup';
            signupEvent['provider'] = 'google';
            this.auth.logAuthUserAction(signupEvent);
            /* input to be defined (return_url) forward to reurn url */
        }, err => {
            // message service to be used to display this message
            // alert('Login failed!');
            const message = 'Could not log you in';
            this.messages.showErrors(message);
            // console.log(message, err);
        });
    }
    signup(name, email, password, subscribeToNl) {
        const register$ = this.auth.registerUser(name.value, email.value, password.value, subscribeToNl.checked);
        this.loading.showLoaderUntilCompleted(register$).subscribe(() => {
            const signupEvent = {};
            signupEvent['event'] = -1;
            signupEvent['type'] = 'signup';
            signupEvent['provider'] = 'password';
            this.auth.logAuthUserAction(signupEvent);
            /* input to be defined (return_url) forward to reurn url */
        }, err => {
            // message service to be used to display this message
            // alert('Login failed!');
            const message = 'Could not log you in';
            this.messages.showErrors(message);
            // console.log(message, err);
        });
    }
}
SignupComponent.ɵfac = function SignupComponent_Factory(t) { return new (t || SignupComponent)(ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AuthStoreService), ɵɵdirectiveInject(MessagesService), ɵɵdirectiveInject(LoadingService)); };
SignupComponent.ɵcmp = ɵɵdefineComponent({ type: SignupComponent, selectors: [["auth-signup"]], decls: 78, vars: 10, consts: [[1, "login-module"], [1, "login-grid"], [1, "terra-info"], ["size", "12", 1, "montserrat", "main-title"], ["size", "12", 1, "sub-title"], [1, "login-row"], ["size", "12", 1, "rightPanel"], ["size", "12"], [1, "signupTagline", "montserrat"], ["expand", "full", 1, "actionable", 3, "click"], ["name", "logo-google", 2, "margin-right", "15px"], [2, "margin-top", "20px"], [1, "seperator"], [1, "seperatorText"], ["lines", "full", 1, "signupFormItem"], ["position", "floating"], ["type", "text", "required", ""], ["name", ""], ["email", ""], ["type", "password", "required", ""], ["password", ""], ["lines", "none", "text-wrap", ""], ["slot", "start", 2, "margin-right", "10px"], ["checked", ""], ["text-wrap", "", 2, "font-size", "15px"], ["required", "", "slot", "start", 2, "margin-right", "10px", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["ctrl", "ngModel"], ["href", "https://www.terra.do/terms-of-services/", "target", "_blank"], ["href", "https://www.terra.do/media-release", "target", "_blank"], ["href", "https://www.terra.do/privacy-policy/", "target", "_blank"], ["type", "submit", "expand", "block", 1, "actionable", "yellowButton", 3, "disabled", "click"], [1, "forgotContainer"], [1, "forgotPassword-text", "secound-title"], [3, "click"]], template: function SignupComponent_Template(rf, ctx) { if (rf & 1) {
        const _r6 = ɵɵgetCurrentView();
        ɵɵelementStart(0, "ion-content", 0);
        ɵɵelement(1, "util-messages");
        ɵɵelementStart(2, "ion-grid", 1);
        ɵɵelementStart(3, "ion-row", 2);
        ɵɵelementStart(4, "ion-col", 3);
        ɵɵelementStart(5, "b");
        ɵɵtext(6);
        ɵɵelementEnd();
        ɵɵtext(7);
        ɵɵelementEnd();
        ɵɵelementStart(8, "ion-col", 4);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(10, "ion-row", 5);
        ɵɵelementStart(11, "ion-col", 6);
        ɵɵelementStart(12, "ion-grid");
        ɵɵelementStart(13, "ion-row");
        ɵɵelementStart(14, "ion-col", 7);
        ɵɵelementStart(15, "div", 8);
        ɵɵtext(16, " New to Terra.do? Sign up ");
        ɵɵelementEnd();
        ɵɵelementStart(17, "ion-button", 9);
        ɵɵlistener("click", function SignupComponent_Template_ion_button_click_17_listener() { ɵɵrestoreView(_r6); const _r3 = ɵɵreference(43); return ctx.signupUsingGoogle(_r3); });
        ɵɵelement(18, "ion-icon", 10);
        ɵɵtext(19, " Sign up with Google ");
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 11);
        ɵɵelement(21, "div", 12);
        ɵɵelementStart(22, "div", 13);
        ɵɵtext(23, "Or");
        ɵɵelementEnd();
        ɵɵelement(24, "div", 12);
        ɵɵelementEnd();
        ɵɵelementStart(25, "form");
        ɵɵelementStart(26, "ion-item", 14);
        ɵɵelementStart(27, "ion-label", 15);
        ɵɵtext(28, "Name");
        ɵɵelementEnd();
        ɵɵelement(29, "ion-input", 16, 17);
        ɵɵelementEnd();
        ɵɵelementStart(31, "ion-item", 14);
        ɵɵelementStart(32, "ion-label", 15);
        ɵɵtext(33, "Email");
        ɵɵelementEnd();
        ɵɵelement(34, "ion-input", 16, 18);
        ɵɵelementEnd();
        ɵɵelementStart(36, "ion-item", 14);
        ɵɵelementStart(37, "ion-label", 15);
        ɵɵtext(38, "Password");
        ɵɵelementEnd();
        ɵɵelement(39, "ion-input", 19, 20);
        ɵɵelementEnd();
        ɵɵelementStart(41, "ion-item", 21);
        ɵɵelement(42, "ion-checkbox", 22, 23);
        ɵɵelementStart(44, "ion-label", 24);
        ɵɵtext(45, "Subscribe to our newsletter.");
        ɵɵelement(46, "br");
        ɵɵtext(47, "Two minutes of climate knowledge each weekday");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(48, "ion-item", 21);
        ɵɵelementStart(49, "ion-checkbox", 25, 26);
        ɵɵlistener("ngModelChange", function SignupComponent_Template_ion_checkbox_ngModelChange_49_listener($event) { return ctx.terms = $event; });
        ɵɵelementEnd();
        ɵɵelementStart(51, "ion-label", 24);
        ɵɵtext(52, "I agree that I have read, consent and agree to the ");
        ɵɵelementStart(53, "a", 27);
        ɵɵtext(54, "Terms of Services");
        ɵɵelementEnd();
        ɵɵtext(55, " and ");
        ɵɵelementStart(56, "a", 28);
        ɵɵtext(57, "Media Release");
        ɵɵelementEnd();
        ɵɵtext(58, ".* ");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(59, "ion-item", 21);
        ɵɵelementStart(60, "ion-checkbox", 25, 26);
        ɵɵlistener("ngModelChange", function SignupComponent_Template_ion_checkbox_ngModelChange_60_listener($event) { return ctx.privacy = $event; });
        ɵɵelementEnd();
        ɵɵelementStart(62, "ion-label", 24);
        ɵɵtext(63, "I agree that I have read, consent and agree to the ");
        ɵɵelementStart(64, "a", 29);
        ɵɵtext(65, "Privacy Policy");
        ɵɵelementEnd();
        ɵɵtext(66, ".*");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(67, "ion-row");
        ɵɵelementStart(68, "ion-col");
        ɵɵelementStart(69, "ion-button", 30);
        ɵɵlistener("click", function SignupComponent_Template_ion_button_click_69_listener() { ɵɵrestoreView(_r6); const _r0 = ɵɵreference(30); const _r1 = ɵɵreference(35); const _r2 = ɵɵreference(40); const _r3 = ɵɵreference(43); return ctx.signup(_r0, _r1, _r2, _r3); });
        ɵɵtext(70, "Create Account");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(71, "ion-row");
        ɵɵelementStart(72, "ion-col", 31);
        ɵɵelementStart(73, "div", 32);
        ɵɵtext(74, " Already have an account? ");
        ɵɵelementStart(75, "a", 33);
        ɵɵlistener("click", function SignupComponent_Template_a_click_75_listener() { return ctx.gotosigninpage(); });
        ɵɵtext(76, "Sign in");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(77, "util-loading");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(6);
        ɵɵtextInterpolate(ctx.auth.titles.main);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.auth.titles.extra, " Terra.do");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.auth.titles.sub);
        ɵɵadvance(40);
        ɵɵproperty("ngModel", ctx.terms)("ngModelOptions", ɵɵpureFunction0(8, _c0));
        ɵɵadvance(11);
        ɵɵproperty("ngModel", ctx.privacy)("ngModelOptions", ɵɵpureFunction0(9, _c0));
        ɵɵadvance(9);
        ɵɵproperty("disabled", !ctx.privacy || !ctx.terms);
    } }, directives: [IonContent, MessagesComponent, IonGrid, IonRow, IonCol, IonButton, IonIcon, ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm, IonItem, IonLabel, IonInput, TextValueAccessor, IonCheckbox, BooleanValueAccessor, RequiredValidator, NgControlStatus, NgModel, LoadingComponent], styles: [".logo[_ngcontent-%COMP%]{display:block;margin-top:15px}.leftPanel[_ngcontent-%COMP%]{background:hsla(0,0%,86.3%,.12);height:100vh}.login-tagline[_ngcontent-%COMP%]{color:#000;font-family:var(--ion-font-family-heading);font-size:44px;font-weight:900;line-height:50px;margin-top:120px}.login-subtext[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-size:22px;line-height:32px;margin-top:10px}ion-col[_ngcontent-%COMP%], ion-grid[_ngcontent-%COMP%]{--ion-grid-padding:0;padding:0}.login-leaf-full[_ngcontent-%COMP%]{bottom:0;left:0;position:absolute;width:70%}.loginDiv[_ngcontent-%COMP%]{color:#000;font-family:Montserrat,sans-serif;font-size:18px;font-style:normal;font-weight:400;line-height:20px;margin:45px 0;position:absolute;right:0}.seperator[_ngcontent-%COMP%]{border-top:1px solid #d3d3d3;display:inline-block;width:44%}.seperatorText[_ngcontent-%COMP%]{color:#9f9f9f;display:inline-block;font-size:18px;font-weight:400;line-height:18px;text-align:center;vertical-align:sub;width:12%}.actionable[_ngcontent-%COMP%], .seperatorText[_ngcontent-%COMP%]{font-family:var(--ion-font-family-text);font-style:normal}.actionable[_ngcontent-%COMP%]{border-radius:4px;color:#fff;font-size:20px;font-weight:500;height:50px;letter-spacing:0;line-height:28px;text-transform:capitalize}.yellowButton[_ngcontent-%COMP%]{--background:linear-gradient(180deg,#ffd555,#ffc410);background:linear-gradient(180deg,#ffd555,#ffc410);color:#000}.signupFormItem[_ngcontent-%COMP%]{--border-radius:4px;--border-width:1px;margin:20px 0}a[_ngcontent-%COMP%]{cursor:pointer;text-decoration:none}", ".terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{border-bottom:1px solid #fff;color:#fff;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{color:#fff;font-size:16px;line-height:150%;padding-bottom:40px;padding-top:20px;text-align:center}.login-grid[_ngcontent-%COMP%]{margin:auto;max-width:470px}.login-row[_ngcontent-%COMP%]{background:#fff;border-radius:8px;box-shadow:0 0 8px rgba(0,0,0,.25);padding:20px}.signupTagline[_ngcontent-%COMP%]{color:#000;font-size:32px;letter-spacing:-1px;line-height:120%;padding-bottom:20px;text-align:center}.forgotContainer[_ngcontent-%COMP%]{padding-top:20px}.forgotContainer[_ngcontent-%COMP%]   .forgotPassword-text[_ngcontent-%COMP%]{font-size:18px;font-style:normal;font-weight:500;line-height:10px;text-align:left}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:10px!important}@media (max-width:575.98px){.terra-info[_ngcontent-%COMP%]   .main-title[_ngcontent-%COMP%]{font-size:24px;padding-bottom:10px}.terra-info[_ngcontent-%COMP%]   .sub-title[_ngcontent-%COMP%]{font-size:16px;padding-bottom:20px}.login-row[_ngcontent-%COMP%]{padding:10px}.forgotContainer[_ngcontent-%COMP%]   .secound-title[_ngcontent-%COMP%]{padding-top:20px!important}}@media (min-width:768.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:60px!important;padding-top:60px!important}}@media (max-width:768px) and (min-width:510.02px){.login-grid[_ngcontent-%COMP%]{padding-bottom:80px!important;padding-top:80px!important}}@media (max-width:510px){.login-grid[_ngcontent-%COMP%]{padding:30px 20px 20px!important}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SignupComponent, [{
        type: Component,
        args: [{
                selector: 'auth-signup',
                templateUrl: './signup.component.html',
                styleUrls: ['./signup.component.css', '../common.scss'],
            }]
    }], function () { return [{ type: Router }, { type: AuthStoreService }, { type: MessagesService }, { type: LoadingService }]; }, null); })();

class AuthLibModule {
    static forRoot() {
        return {
            ngModule: AuthLibModule,
            providers: [AuthStoreService, AuthGuard],
        };
    }
}
AuthLibModule.ɵmod = ɵɵdefineNgModule({ type: AuthLibModule });
AuthLibModule.ɵinj = ɵɵdefineInjector({ factory: function AuthLibModule_Factory(t) { return new (t || AuthLibModule)(); }, providers: [MessagesService, LoadingService, CookieService], imports: [[
            CommonModule,
            IonicModule,
            FormsModule,
            ReactiveFormsModule,
            UtilLibModule,
            CloudinaryModule.forRoot({ Cloudinary }, {
                cloud_name: 'terra-do',
            }),
            StoreModule.forFeature('auth', authReducer),
            EffectsModule.forFeature([AuthEffects]),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AuthLibModule, { declarations: [AuthLibComponent,
        LoginComponent,
        SignupComponent,
        LeftPanelComponent,
        ForgotPasswordComponent,
        ForgotEmailComponent,
        LoginemaillinkComponent], imports: [CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        UtilLibModule, CloudinaryModule, StoreFeatureModule, EffectsFeatureModule], exports: [AuthLibComponent,
        LoginComponent,
        SignupComponent,
        ForgotPasswordComponent,
        ForgotEmailComponent,
        LoginemaillinkComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthLibModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AuthLibComponent,
                    LoginComponent,
                    SignupComponent,
                    LeftPanelComponent,
                    ForgotPasswordComponent,
                    ForgotEmailComponent,
                    LoginemaillinkComponent,
                ],
                imports: [
                    CommonModule,
                    IonicModule,
                    FormsModule,
                    ReactiveFormsModule,
                    UtilLibModule,
                    CloudinaryModule.forRoot({ Cloudinary }, {
                        cloud_name: 'terra-do',
                    }),
                    StoreModule.forFeature('auth', authReducer),
                    EffectsModule.forFeature([AuthEffects]),
                ],
                exports: [
                    AuthLibComponent,
                    LoginComponent,
                    SignupComponent,
                    ForgotPasswordComponent,
                    ForgotEmailComponent,
                    LoginemaillinkComponent,
                ],
                providers: [MessagesService, LoadingService, CookieService],
            }]
    }], null, null); })();

/*
 * Public API Surface of auth-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { authLib_actions as AuthActions, AuthGuard, AuthLibComponent, AuthLibModule, AuthLibService, AuthStoreService, ForgotEmailComponent, ForgotPasswordComponent, LoginComponent, LoginemaillinkComponent, SignupComponent, authReducer, initialAuthState, userProfileDetail };
//# sourceMappingURL=auth-lib.js.map
